import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Grid,
  IconButton,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { getPaymentMethod } from "redux/actions/UserPayment";
import CommonAccordian from "components/commonAccordian/CommonAccordian";
import Map from "pages/Map/Map";
import CommonDialog from "components/commonDialog/CommonDialog";
import { paymentAccordian } from "./AccordianData";
import { tripEnumObject } from "utils/enumObject";

function PaymentMethod() {
  const state = useLocation();
  const navigate = useNavigate();
  const path = sessionStorage.getItem("paths");
  const type = state?.state?.tripData?.type;
  const status =
    type === tripEnumObject?.rental
      ? "Rental"
      : type === tripEnumObject?.airport
      ? "Airport"
      : type === tripEnumObject?.outStationRound
      ? "Outstation"
      : "Oneway";
  const [open, setOpen] = useState(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const handleClose = () => {
    setOpen(false);
    window.location.replace("/home");
    sessionStorage.clear();
  };
  const dispatch = useDispatch();
  const payBtn = () => {
    setOpen(true);
    const payload = {
      tripId: state?.state?.tripData?.id,
      paymentType: 1,
    };
    dispatch(getPaymentMethod(payload));
  };

  const discountAmount = state?.state?.tripData?.CouponUsageDetails?.discountAmount

  return (
    <Grid
      container
      justifyContent="space-between"
      className="dashboardBgColor"
      md={12}
    >
      <Grid
        container
        item
        direction="column"
        className="bgWhite"
        justifyContent="space-between"
        md={5.5}
        xs={11}
      >
        <Grid item className="padding30">
          <Typography className="font20 fontMedium colorBlue">
            Payment Method
          </Typography>
          <CommonAccordian accordianData={paymentAccordian} />
        </Grid>
        <Grid item container alignItems="center">
          <Typography className="font14 colorGrey width100 justifyCenter p10">Note - Final invoice will be generated only after the trip is complete</Typography>
          <Grid item container justifyContent="space-between" md={12} className="borderTop32px boxShadowTopLightGrey padding30">
            <Grid item>
              <Typography className="font16 fontMedium">To pay </Typography>
            </Grid>
            <Grid item>
              <Typography className="font16 fontMedium">{"₹ " +  parseFloat(state?.state?.tripData?.price)?.toFixed(2)}</Typography>
            </Grid>
          </Grid>

          {discountAmount &&<Grid item sm={12} className="justifyCenter padding30 backgroundLightBlue borderTop32px"> <Typography className="font16 colorBlue"> You saved ₹{discountAmount} on this trip</Typography></Grid>}
          <Grid item container sm={12} className={`justifyCenter ${discountAmount ? 'backgroundLightBlue' : ''}`}> 
            <Grid item sm={12} className="borderTop32px boxShadowTopGrey backgroundColorWhite paddingTop10Left20"><Button className="primaryBtn width100 " onClick={payBtn}>
            Pay Now
          </Button>
          </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid item md={5.5}>
        {path?.length > 0 && (
          <Map paths={JSON.parse(path)} status={status} mapheight={true} />
        )}
      </Grid>
      {open && (
        <CommonDialog
          open={open}
          handleClose={handleClose}
          payment={true}
          title="Card Auth"
          content="link has been sent to your registered email for card authorization."
          btn={true}
        />
      )}
    </Grid>
  );
}

export default PaymentMethod;
